module.exports = __webpack_public_path__ + "img/smart.42e8acb3.png";